import React, { useRef } from 'react';
import { useToggleState } from '@react-stately/toggle';
import { useToggleButton } from '@react-aria/button';
import { useLabel } from '@react-aria/label';
import {
  StyledToggle,
  HiddenToggleInput,
  ToggleLabel,
  ToggleWrapper,
} from 'src/components/Input/ToggleInput/ToggleInput.style';
import { IToggle } from 'src/components/Input/ToggleInput/ToggleInput.i';

export const ToggleInput = (props: IToggle) => {
  const ref = useRef();
  const state = useToggleState(props);
  const { buttonProps } = useToggleButton({ ...props, elementType: 'input' }, state, ref);
  const { labelProps, fieldProps } = useLabel(props);

  /* NOTE!
   * useToggleButton returns an onClick method which we need to use for aria
   * Using both this onClick AND onChange results in a react error(trying to change CatalogPage while rendering ToggleInput)
   * Omitting onChange from the checkbox input also results in an warning
   * Work around: use onClick for interaction logic, but pass an empty function for onChange
   */
  return (
    <div>
      <ToggleLabel {...labelProps}>
        {props.label}
        <ToggleWrapper>
          <HiddenToggleInput {...fieldProps} {...buttonProps} type='checkbox' checked={props.on} onChange = {()=>{}} ref = {ref}/>
          <StyledToggle />
        </ToggleWrapper>
      </ToggleLabel>
    </div>
  );
};
